import { z } from 'zod';

export const bdmLinkStudyIdSchema = z.string().max(32);
export const bdmLinkSchema = z.string().max(2048);
export const bdmLinksImportRow = z.array(z.string());
